module.exports = __webpack_public_path__ + "img/H-B-2-unload-connect-shadow.4baa8eee.png";